// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2F-NK","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3jsrW"};